import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './ui.module.css';

export type StripTone = 'neutral' | 'accent';

/**
 * Значение с подписью и цветной засечкой слева.
 *
 * Тот же приём, что у плашки-предупреждения и у снимка в журнале, только
 * здесь он несёт пару: приглушённая засечка — то, что было, бирюзовая — то,
 * что предлагают. В макете различия анкеты набраны именно так, и это важнее,
 * чем кажется: двумя одинаковыми карточками подряд читатель сверяет их
 * глазами, а тут порядок называет сам цвет.
 */
export function Strip({
  label,
  tone = 'neutral',
  children,
}: {
  label: string;
  tone?: StripTone;
  children: ReactNode;
}) {
  return (
    <div className={clsx(styles.strip, TONES[tone])}>
      <span className={styles.stripLabel}>{label}</span>
      <div className={styles.stripBody}>{children}</div>
    </div>
  );
}

const TONES: Record<StripTone, string> = {
  neutral: styles.stripNeutral,
  accent: styles.stripAccent,
};
